import React, {useEffect, useState} from 'react';
import moment from "moment"
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Grid from "@material-ui/core/Grid"
import {formatCurrency, calcTotalPayed, calcTotalRemaining, calcTotalTour, getModelPrices1, getTotalRefounded, getTourSuplements} from "../util"
import {
    HeaderTypo,
    StyledPanelSummary,
    BordedBox,
    StyledTableTd,
    StyledTableRowHead,
    InfoSpan
} from "./styles/boxPaymentsClients/style"

import {
    StyledTableCell,
    StyledRowCell,
    StyledLink,
    Divider,
    TableContainer
} from "./styles/resumenPayment/styles"

export const PaymentsClients = (
    data,
    price,
    isOpen,
) => {
    const charges = data.data.payments[0].charges
    const [rentalPaymentsInfo, setRentalPaymentsInfo] = useState("")
    const [isOpenAcordeon, setIsOpenAcordeon] = useState(false)

    useEffect(() => {
        const getPrices = async () => {
            const apiBreakdown = data.data && data.data.calculated_price_dynamic
                ? data.data.calculated_price_dynamic.breakdown
                : null
            const priceFirstChoice = await getModelPrices1(
                data.data,
                data.price.models.data,
                data.price.prices.data,
                data.data.vehicle_model_id
            );
            const totalTourCost = await calcTotalTour(data.data, data.price, priceFirstChoice, true)
            const totalPayed = calcTotalPayed(data.data)
            const totalCost = apiBreakdown ? (apiBreakdown.total || 0) : totalTourCost.totalCost
            const totalRemaining = calcTotalRemaining(data.data, totalCost)
            const totalRefounded = getTotalRefounded(data.data)
            const totalSuplements = getTourSuplements(data.data)
            const aux = {
                totalTourCost: totalCost,
                totalPayed,
                remaining: totalRemaining,
                totalRefounded,
                totalSuplements: totalSuplements.payedSuplement + totalSuplements.pendingSuplement
            }
            setRentalPaymentsInfo(aux)
        }
        getPrices()
    }, [])
    
    const handleOpenAccodeon = () => {
        if(isOpenAcordeon){
            setIsOpenAcordeon(false)
        }else{
            setIsOpenAcordeon(true)
        }
    }
    return (
        <div style={{marginBottom: "15px"}}>
            <ExpansionPanel style={{borderRadius:"10px", boxShadow: "0px 0px 9px 0px rgba(0,0,0,.12)"}} onChange={handleOpenAccodeon}>
                <StyledPanelSummary className={isOpenAcordeon ? "" : "separate"}>
                    <div style={{padding:"0px"}}>
                        <HeaderTypo style={{display:"flex", flexDirection:"column"}}>
                            Payments
                            <InfoSpan >(Haz clic para obtener más detalles)</InfoSpan>
                        </HeaderTypo>
                    </div>
                    <Table aria-label="customized table">
                        <TableBody>

                            <StyledRowCell>
                                <StyledTableCell className="light">Total cost</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}} className='grow' align="right">{`${formatCurrency(rentalPaymentsInfo.totalTourCost)}`}</StyledTableCell>
                            </StyledRowCell>
                            
                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>

                            <StyledRowCell>
                                <StyledTableCell className="light">Paid</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}}  align="justify">{`${formatCurrency(rentalPaymentsInfo.totalPayed)}`}</StyledTableCell>
                            </StyledRowCell>

                            {!isOpenAcordeon && 
                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell style={{textAlign:"right"}} colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>}

                            {!isOpenAcordeon && 
                            <StyledRowCell >
                                <StyledTableCell className="light">Remaining</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}} align="center" className='grow'>{`${formatCurrency(rentalPaymentsInfo.remaining)}`}</StyledTableCell>
                            </StyledRowCell> }

                        </TableBody>
                    </Table>
                </StyledPanelSummary>
                <ExpansionPanelDetails style={{display:"block", padding :"0px"}}>
                    <Table aria-label="customized table">
                        <TableBody>
                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>

                            <StyledRowCell>
                                <StyledTableCell className="light">Total refounded</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}}  align="justify" className='grow'>{`${formatCurrency(rentalPaymentsInfo.totalRefounded)}`}</StyledTableCell>
                            </StyledRowCell>

                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>

                             {/* <StyledRowCell>
                                <StyledTableCell className="light">Total rewards</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}}  align="justify" className='grow'>{`${formatCurrency(data.data.booking.rewards || 0)}`}</StyledTableCell>
                            </StyledRowCell>

                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>

                             <StyledRowCell>
                                <StyledTableCell className="light">Total suplements</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}}  align="justify" className='grow'>{`${formatCurrency(rentalPaymentsInfo.totalSuplements || 0)}`}</StyledTableCell>
                            </StyledRowCell>

                            <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell> */}

                          {/*   <StyledRowCell >
                                <StyledTableCell className="light">Total discount</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}}  align="center"  className='grow'>{`${formatCurrency(data.data.discount || 0)}`}</StyledTableCell>
                            </StyledRowCell> */}

                        {/*     <StyledRowCell style={{height:"15px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell> */}

                            {isOpenAcordeon && 
                            <StyledRowCell >
                                <StyledTableCell className="light">Remaining</StyledTableCell>
                                <StyledTableCell style={{textAlign:"right"}} align="center" className='grow'>{`${formatCurrency(rentalPaymentsInfo.remaining)}`}</StyledTableCell>
                            </StyledRowCell> }

                            <StyledRowCell style={{height:"20px"}}>
                                <StyledTableCell colSpan={2}><Divider /></StyledTableCell>
                            </StyledRowCell>
                        </TableBody>
                    </Table>
                    <div style={{padding: "8px 24px 24px"}}>
                        <Table aria-label="customized table" style={{ tableLayout: 'fixed', width: '90%', margin: 'auto' }}>
                                <TableHead>
                                        <StyledTableTd style={{textAlign:"center"}} className='head'>Value</StyledTableTd>
                                        <StyledTableTd style={{textAlign:"center"}} className='head'>Date</StyledTableTd>
                                        <StyledTableTd style={{textAlign:"center"}} className='head'>Status</StyledTableTd>
                                        <StyledTableTd style={{textAlign:"center"}} className='head'>Refound</StyledTableTd>
                                </TableHead>
                            <TableBody>

                                <StyledRowCell style={{height:"15px"}}>
                                </StyledRowCell>

                                {
                                    charges.map((charge) => (
                                        <StyledRowCell
                                            key={charge.id}
                                        >
                                            <StyledTableTd style={{textAlign:"center"}} align="right">{`${formatCurrency(charge.value)}`}</StyledTableTd>
                                            <StyledTableTd style={{textAlign:"center"}} className="light" align="right">{moment.utc(charge.date).format("YYYY-MM-DD")}</StyledTableTd>
                                            <StyledTableTd style={{textAlign:"center"}} align="right">{`${charge.status === true ? "Paid" : "Pending"  }`}</StyledTableTd>
                                            <StyledTableTd style={{textAlign:"center"}} className="light" align="right">{`${formatCurrency(charge.refunded_value)}`}</StyledTableTd>
                                        </StyledRowCell>
                                    ))
                                }

                            </TableBody>
                        </Table>
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/boxPaymentsClients.js